import { createContext, useContext, useEffect } from "react";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  useEffect(() => {
    // Site is permanently dark. Remove any old day/night preference.
    document.body.classList.add("gece");
    document.cookie = "ozalp-mod=gece;path=/;max-age=31536000";
  }, []);

  return (
    <ThemeCtx.Provider value={{ gece: true, toggle: () => {} }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
